export default __webpack_public_path__ + "static/media/one.401583cb.svg";